import React from 'react';

import './style.scss';
import classNames from 'classnames';

export interface QuizCardConfig {
  borderStyle?: 'solid' | 'rainbow';
  contentBackground?: 'light-body' | 'lighter' | 'transparent';
  onSelectedBackground?: 'lighter' | 'rainbow' | 'transparent';
  onSelectedContentBackground?: 'lighter' | 'transparent';
  textColor?: 'light' | 'dark';
}

interface QuizCardProps {
  cardId: number;
  children: React.ReactNode;
  className?: string;
  config?: QuizCardConfig;
  onCardClick: (cardNumber: number) => void;
  selected?: boolean;
}
const QuizCard = ({
  cardId,
  children,
  className,
  config: {
    borderStyle = 'rainbow',
    contentBackground = 'light-body',
    onSelectedBackground = 'rainbow',
    onSelectedContentBackground = 'lighter',
    textColor = 'light',
  } = {},
  onCardClick,
  selected,
}: QuizCardProps) => {
  return (
    <div
      data-testid="QuizCard"
      className={classNames(
        'QuizCard',
        `QuizCard__text_${textColor}`,
        selected
          ? `QuizCard__background_selected_${onSelectedBackground}`
          : `QuizCard__background_${borderStyle}`,
        className,
      )}
      onClick={() => onCardClick(cardId)}
    >
      <div
        className={classNames(
          'QuizCard__content',
          `QuizCard__content__background_${
            selected ? onSelectedContentBackground : contentBackground
          }`,
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default QuizCard;
